"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityOn = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SecurityOn = function () {
    return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20.12 5.82A3 3 0 0121 7.94v5.85a8 8 0 01-3.09 6.31l-4.08 3.18a2 2 0 01-1.23.42h-1.2a2 2 0 01-1.23-.42L6.09 20.1A8 8 0 013 13.79V7.94a3 3 0 01.88-2.12l3.53-3.53a2 2 0 011.42-.59h6.34a2 2 0 011.42.59l3.53 3.53zm-9.39 9.74l5.62-5.62v-.01a.5.5 0 000-.7l-.53-.53a.5.5 0 00-.7 0l-4.74 4.73-1.5-1.49a.48.48 0 00-.7 0l-.53.53a.5.5 0 000 .71l2.38 2.38a.48.48 0 00.7 0z", clipRule: "evenodd" }));
};
exports.SecurityOn = SecurityOn;
//# sourceMappingURL=security-on.js.map